import { FloraTypography } from '@grupoboticario/flora-react'

export const CatalogAccordionTitle = ({ isOpened = false }) => {
  return (
    <FloraTypography
      fontSize="subtitle"
      viewport="mobile"
      autotagging-flora="on"
    >
      {isOpened ? 'Fechar catálogo do ciclo' : 'Confira o catálogo do ciclo'}
    </FloraTypography>
  )
}
